import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import BalancedLifestyle from './pages/BalancedLifestyle';
import Pregnancy from './pages/Pregnancy';
import StandardDrinks from './pages/StandardDrinks';
import Tips from './pages/Tips';
import ParentsTeens from './pages/ParentsTeens';
import Smashed from './pages/Smashed';
import WhoWeAre from './pages/WhoWeAre';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/balanced-lifestyle" element={<BalancedLifestyle />} />
          <Route path="/pregnancy" element={<Pregnancy />} />
          <Route path="/standard-drinks" element={<StandardDrinks />} />
          <Route path="/tips" element={<Tips />} />
          <Route path="/parents-teens" element={<ParentsTeens />} />
          <Route path="/smashed" element={<Smashed />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;